import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { UploadQr } from 'page/ProfileScreen/UploadQrModal/UploadQr'
import { store } from 'store/store'

export const UploadStep = observer(() => {
  const onCancel = useLatestCallback(() => {
    store.profile.basic.step = 'first'
  })

  const onDone = useLatestCallback(() => {
    store.profile.basic.step = 'first'
  })

  return (
    <Vertical gap={40}>
      <Space center>
        <UploadQr size={400} photo="selfie" onDone={onDone} />
      </Space>
      <Vertical gap={8}>
        <Typo size={32} semi upper center>
          {i18n('PointYourCamera')}
        </Typo>
        <Typo size={24} secondary upper center>
          {i18n('TakePhotoFromYourPhoneOrUploadFromFiles')}
        </Typo>
      </Vertical>
      <Button large action={onCancel}>
        {i18n('Cancel')}
      </Button>
    </Vertical>
  )
})
